import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import * as i18next from 'i18next';
import moment from 'moment';
import * as api from 'core/api';
import * as flights from 'core/flights';
import * as utils from 'core/utils';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

@WithRender
@Component
export default class FlightsSearchResultsItemComponent extends Vue {
    @Prop()
    flight: flights.FlightModel;

    @Prop()
    flightIndex: number;

    @Prop()
    filterFlight: flights.FlightFilterModel;

    @Prop()
    gaParams: utils.GoogleAnalyticsParams;

    @Prop({ type: String })
    searchId: string | null;

    @Prop()
    cheapestFlightId: string;

    @Prop()
    fasterFlightId:  string;

    @Prop()
    bestFlightId:  string;

    tooltipActivator: EventTarget | null = null;
    tooltipContent: string | null = null;

    get promoIsActive() {
        return moment().isBefore(moment('25.12.2019', 'DD.MM.YYYY'));
    }

    onFlightRoute(flight: flights.FlightModel) {
        if (flight.externalPartner) {
            const partnerName: string = flight.externalPartner.name.replace(/\s/g, '').toLowerCase();
            (<any>this).$ga.sendEvent('flights.results', `btn.partner.${partnerName}`, `flights.results.btn.partner.${partnerName}`, this.gaParams);
        }
        if (flight.promo_coupon_name) {
            utils.Cookies.g2scpnSet(flight.promo_coupon_name);
        }
    }

    onTooltipTargetMouseEnter(event: MouseEvent, ref: string) {
        this.tooltipActivator = event.target;
        this.tooltipContent = (<any>this.$refs)[ref][0].innerHTML;
        (<any>this.$refs).tooltip.isActive = true;
    }

    onTooltipTargetMouseLeave() {
        this.tooltipActivator = null;
        (<any>this.$refs).tooltip.isActive = false;
    }

    getBaggageLabel(flightBaggage: api.FlightBaggage, isCabin: boolean): string {
        return utils.Baggage.getLabel(flightBaggage, isCabin);
    }

    getBaggageValue(leg: flights.LegModel): string {
        const v = utils.Baggage.getValue(leg);

        if (v === i18next.t('label_baggage_without_short')) {
            return i18next.t('label_baggage_paid_short')
        } else {
            return v;
        }
    }

    getBonusesLabel(flight: flights.FlightModel): string {
        const b = i18next.t('numerous_bonus', { count: Math.round(flight.billingPrice * 1 / 100) });
        return i18next.t('label_bonuses_you_will_get', <any>{ i: b });
    }

    getLegDurationLabel(leg: flights.LegModel): string {
        return i18next.t('label_flight_duration_total', <any>{i: (<any>leg.duration).format(i18next.t('format_duration'))});
    }

    getSegmentLabel(leg: flights.LegModel, segment: flights.SegmentModel, segmentIndex: number): string {
        if (segment.arrivalDestination.iataCode === leg.segments[segmentIndex + 1].departureDestination.iataCode) {
            return segment.arrivalDestination.iataCode;
        } else {
            return segment.arrivalDestination.city.iataCode;
        }
    }

    hasBaggage(leg: flights.LegModel): boolean {
        return leg.baggage && (leg.baggage.pieceWeight > 0 || leg.baggage.pieces > 0);
    }

    hasBaggageCabin(leg: flights.LegModel): boolean {
        return leg.baggageCabin && (leg.baggageCabin.pieceWeight > 0 || leg.baggageCabin.pieces > 0);
    }

    onFlightDetails(flight: flights.FlightModel) {
        this.$emit('flight-details', flight);
    }

    onFlightGroupDetails(flight: flights.FlightModel) {
        this.$emit('flight-group-details', flight);
    }

    getLegSegmentsAirlinesDistinct(leg: flights.LegModel) {
        const result: api.Airline[] = [];
        const map: string[] = [];

        for (const segment of leg.segments) {
            if (!map.includes(segment.airline.uniqueId)) {
                map.push(segment.airline.uniqueId);
                result.push(segment.airline);
            }
        }

        return result;
    }

    emitPromoTagClick() {
        this.$emit('promo-tag-click');
    }

    getFlightRouteToParam(flight: flights.FlightModel, offer?: api.FlightSearchExternalOffer) {
        if (flight.externalPartner || offer) {
            let r: any = {
                path: '/partner',
                query: {
                    sid: this.searchId,
                    fid: flight.uniqueId,
                    pn: flight.externalPartner?.name
                }
            };

            if (offer) {
                r.query.pn = offer.partnerName;
                r.query.esid = offer.externalSearchId;
                r.query.epid = offer.partnerId;
                r.query.efid = offer.externalFlightId;
                r.query.efbp = offer.billingPrice;
            }

            return r;            
        } else {
            return flight.url;
        }
    }
}
